import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, supportedLanguages } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // Get initial language from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('app_language');
    return saved && translations[saved] ? saved : 'en';
  });

  // Save language preference to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('app_language', language);
  }, [language]);

  // Get translation for a key
  const t = (key) => {
    const translation = translations[language]?.[key];
    if (!translation) {
      // Fallback to English if key not found in current language
      return translations['en']?.[key] || key;
    }
    return translation;
  };

  // Change language
  const changeLanguage = (langCode) => {
    if (translations[langCode]) {
      setLanguage(langCode);
    }
  };

  // Get current language info
  const getCurrentLanguage = () => {
    return supportedLanguages.find(lang => lang.code === language) || supportedLanguages[0];
  };

  const value = {
    language,
    setLanguage: changeLanguage,
    t,
    getCurrentLanguage,
    supportedLanguages,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
